import { updateSelectedViewType } from '../actions/publicActions';
import { default as SelectedViewTypeSource } from '../schema/SelectedViewTypeSource';
import { openCalendarBoardView } from 'owa-calendar-board-launch';
import { CalendarViewTypeEnum } from 'owa-calendar-view-type';
import { orchestrator } from 'satcheljs';

orchestrator(openCalendarBoardView, () => {
    updateSelectedViewType(CalendarViewTypeEnum.Board, SelectedViewTypeSource.UserChange);
});
